import Configuration from "../environment";

const decodeToken = (token) => {
    if (token === null || token === undefined) {
        return null;
    }
    try {
        const payload = token.replace("Bearer", "").trim().split(".")[1];
        return JSON.parse(atob(payload));
    } catch (e) {
        return null;
    }
};

export const getToken = () => localStorage.getItem("token");

export const getCurrentUser = () => decodeToken(getToken());

export const hasRole = (role) => {
    const user = getCurrentUser();
    return user?.scopes?.includes(role) ?? false;
};

export const hasAnyRole = (...roles) => roles.some(hasRole);

export const clearSession = () => {
    localStorage.removeItem("token") ;
    localStorage.removeItem("user") ;
    localStorage.removeItem("userPic")
    sessionStorage.removeItem("oidc.user:" + Configuration.oidc_authority + ":" +Configuration.oidc_client_id)
}
